<script lang="ts">

    export let ratio = 1;

    let containerWidth = 100;
    let containerHeight = 100;
    let contentWidth = containerWidth;
    let contentHeight = containerHeight;
    let contentLeft = 0;
    let contentTop = 0;

    $: updateContentSize(containerWidth, containerHeight);

    function updateContentSize(containerWidth: number, containerHeight: number): void {
        contentLeft = 0;
        contentTop = 0;
        contentWidth = containerHeight * (1 / ratio);
        contentHeight = containerWidth * ratio;
        if (contentHeight > containerHeight) {
            contentHeight = containerHeight;
            contentLeft = (containerWidth / 2) - (contentWidth / 2);
        } else {
            contentWidth = containerWidth;
            contentTop = (containerHeight / 2) - (contentHeight / 2);
        }
    }

</script>

<div class="aspect-keeper" bind:clientWidth={containerWidth} bind:clientHeight={containerHeight}>
    <div class="content" style="width: {contentWidth}px; height: {contentHeight}px; top: {contentTop}px; left: {contentLeft}px;">
        <slot />
    </div>
</div>

<style lang="scss">

    .aspect-keeper {
        position: relative;
        width: 100%;
        height: 100%;
    }

    .content {
        position: absolute;
    }

</style>
